import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/authSlice";
import reviewsReducer from "./googleReviews/googleReviewSlice";
import blogsReducer from "./blogs/blogSlice";
import categoryReducer from "./category/categorySlice";
import carouselReducer from "./carousel/carouselSlice";
import vrImagesReducer from "./vrImages/vrImageSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    reviews: reviewsReducer,
    blogs: blogsReducer,
    category: categoryReducer,
    carousels: carouselReducer,
    vrImages: vrImagesReducer
  },
});

export default store;